import styled from "@emotion/styled";
import { colorGuide, colorPalette } from "../../theme/colors";

export const ProgressBarContainer = styled.div<{ noGutter?: boolean }>`
  display: flex;
  width: 100%;
  padding: 2px ${({ noGutter }) => (noGutter ? "0px" : "20px")};
  align-items: center;
  gap: 10px;
  background: ${colorPalette.white[500]};
  box-sizing: border-box;
`;

export const StepsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const Step = styled.div<{ isFilled: boolean }>`
  height: 5px;
  flex: 1 0 0;
  border-radius: 9px;
  background-color: ${({ isFilled }) =>
    isFilled
      ? colorGuide.lightComponents.progressBar.backgroundColor
      : "transparent"};
  border: ${({ isFilled }) =>
    isFilled
      ? "none"
      : `1px solid ${colorGuide.lightComponents.progressBar.backgroundColor}`};
`;

export const ProgressText = styled.div`
  display: flex;
  width: 32px;
  height: 15px;
  padding: 0px 4px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: ${colorGuide.lightComponents.progressBar.color};
`;
